import { useSelector } from 'react-redux';
import { useTranslation } from 'src/hooks';

const Service = () => {
  const { translate } = useTranslation();

  const services = useSelector(
    (state) => state.projectReducer.expertDetail && state.projectReducer.expertDetail.services,
  );
  const costPerHour = useSelector(
    (state) => state.projectReducer.expertDetail && state.projectReducer.expertDetail.costPerHour,
  );
  const costPerProject = useSelector(
    (state) =>
      state.projectReducer.expertDetail && state.projectReducer.expertDetail.costPerProject,
  );
  return (
    <div className="exp-profile__row">
      <div className="exp-profile__uslugi">
        <div className="exp-profile__uslugi__item">
          <div className="exp-content__title">
            <h3>{translate('Profile.service2')}</h3>
          </div>
          <div className="exp-profile__uslugi__wrap">
            <div className="exp-profile__uslugi__wrap2">
              <div className="exp-profile__uslugi__text">{services && services}</div>
              <div className="exp-profile__uslugi__tags mt-3">
                {costPerHour && (
                  <div className="exp-profile__uslugi__tags__item">
                    {costPerHour} грн/{translate('Profile.serHour')}
                  </div>
                )}
                {costPerProject && (
                  <div className="exp-profile__uslugi__tags__item">
                    {translate('Profile.from')} {costPerProject} грн/
                    {translate('Profile.serProekt')}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
